import React from "react";
import { safeLocalFormat } from "../../../utilities/functions";

const localOutDate = ({ row }) => {
  return (
    <div>{row.checkOutDate ? safeLocalFormat(row?.checkOutDate) : "-"}</div>
  );
};

export default localOutDate;
